import React, {useState} from "react";
import * as PropTypes from 'prop-types';
import MainHeader from './MainHeader';
import MainContent from './MainContent';
import MainFooter from './MainFooter';
import MainSubHeader from "./MainSubHeader";
import './Layout.css';
import Notifications from "../../sections/home/Notifications";

const MainLayout = ({ showHeader, showSubHeader, startHigher, showFooter, showTabMenu, footerShowReturnToTop, className, style, subHeaderContent, subHeaderClass, children, permissions, vehicleChange, notifyCount, notifications, refreshNotifications }) => {

  // Notifications Control
  const [notifyModalVisible, setNotifyModalVisible] = useState(false);
  const showNotifications = () => {setNotifyModalVisible(true);}
  
  return (
    <div style={style} className={`dp-main-layout ${className || ''}`}>
      { showHeader && <MainHeader permissions={permissions} notifyToggle={showNotifications} notifyCount={notifyCount} refreshNotifications={refreshNotifications}/> }
      { showSubHeader && subHeaderContent &&
          <MainSubHeader subClass={subHeaderClass}>
            { subHeaderContent }
          </MainSubHeader>
      }
      <MainContent startHigher={startHigher}>
        {children}
      </MainContent>
      { showFooter && <MainFooter showReturnToTop={footerShowReturnToTop} showTabMenu={showTabMenu} notifyToggle={showNotifications}  notifyCount={notifyCount}/> }
      <Notifications notifyModalVisible={notifyModalVisible} setNotifyModalVisible={setNotifyModalVisible} notifications={notifications} refreshNotifications={refreshNotifications} vehicleChange={vehicleChange} />
    </div>
  );
}

// Validate prop type parameters.
MainLayout.propTypes = {
  showHeader: PropTypes.bool,
  showSubHeader: PropTypes.bool,
  startHigher: PropTypes.string,
  showFooter: PropTypes.bool,
  showTabMenu: PropTypes.bool,
  footerShowReturnToTop: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  subHeaderContent: PropTypes.element,
  children: PropTypes.oneOfType([PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)]),
};

MainLayout.defaultProps = {
  showHeader: true,
  showSubHeader: false,
  startHigher: null,
  showFooter: true,
  showTabMenu: true,
  footerShowReturnToTop: false,
  className: undefined,
  style: {},
};

export default MainLayout;